import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import styled, { createGlobalStyle, css } from 'styled-components';
import Config from '../../config';
import { withTheme } from '../../core/ThemeProvider';
import Spacing from '../Spacing';
export var Content = styled.div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-12lbj98-0"
})(["width:auto;"]);
export var AnimationWrapper = styled.div.withConfig({
  displayName: "styles__AnimationWrapper",
  componentId: "sc-12lbj98-1"
})(["z-index:", ";position:fixed;pointer-events:none;"], function (p) {
  return p.zIndex;
});
export var ModalContainer = styled.div.withConfig({
  displayName: "styles__ModalContainer",
  componentId: "sc-12lbj98-2"
})(["pointer-events:auto;position:fixed;padding-top:10vh;left:0;top:0;width:100%;height:100%;background-color:rgba(18,18,18,0.75);box-sizing:border-box;overflow-y:", ";", ";", ";::after{content:'';height:64px;display:block;}"], function (p) {
  return !p.scrollable && 'auto';
}, Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (p) {
  return p.alignCenter && "\n      padding-top:0;\n    ";
}), function (p) {
  return p.alignCenter && "\n    display: flex;\n    align-items: center;\n    justify-content:center;\n    padding-top:0;\n    && > * {\n      flex:1;\n    }\n  ";
});
export var Wrapper = withTheme(styled.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-12lbj98-3"
})(function (_ref) {
  var _coreTheme$modal;
  var coreTheme = _ref.coreTheme,
    bgColor = _ref.bgColor;
  return css(["box-sizing:border-box;position:relative;background-color:", ";text-align:left;margin:0 auto;border-radius:", ";padding:", ";"], bgColor === 'haze' ? coreTheme.cl_ter_l6 : coreTheme.cl_white, coreTheme.rad_xl, ((_coreTheme$modal = coreTheme.modal) === null || _coreTheme$modal === void 0 ? void 0 : _coreTheme$modal.padding) || 0);
}));
export var ContentWrapper = withTheme(styled.div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-12lbj98-4"
})(function (_ref2) {
  var coreTheme = _ref2.coreTheme,
    hasStickyFooter = _ref2.hasStickyFooter;
  return css(["max-height:", ";", " overflow-y:scroll;::-webkit-scrollbar{width:20px;}::-webkit-scrollbar-thumb{background-color:", ";border-radius:9999px;border:8px solid ", ";}scrollbar-width:thin;scrollbar-color:", ";"], hasStickyFooter ? '48vh' : '57vh', Config.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n       max-height: ", ";\n      "])), hasStickyFooter ? '62vh' : '72vh'), coreTheme.cl_ter_l4, coreTheme.cl_white, coreTheme.cl_ter_l4);
})); // Disable background scroll when modal is open

export var NoBackgroundActivity = createGlobalStyle(["body{height:100vh;overflow-y:hidden;}"]);
export var CloseWrapper = styled.span.withConfig({
  displayName: "styles__CloseWrapper",
  componentId: "sc-12lbj98-5"
})(["position:absolute;top:32px;right:25px;cursor:pointer;"]);
export var ScrollBottomFade = withTheme(styled.div.withConfig({
  displayName: "styles__ScrollBottomFade",
  componentId: "sc-12lbj98-6"
})(function (_ref3) {
  var isScrollable = _ref3.isScrollable,
    scrolledBottom = _ref3.scrolledBottom,
    coreTheme = _ref3.coreTheme;
  return css(["display:", ";position:absolute;bottom:1.5rem;", ";left:0;width:100%;height:66px;background:linear-gradient( ", "00,", " );"], !isScrollable || isScrollable && scrolledBottom ? 'none' : 'block', Config.media.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          bottom: 2rem;\n      "]))), coreTheme.cl_white, coreTheme.cl_white);
}));
export var ModalFooterSpacing = styled(Spacing).withConfig({
  displayName: "styles__ModalFooterSpacing",
  componentId: "sc-12lbj98-7"
})(["box-shadow:0px -3px 8px rgba(0,0,0,0.12);"]);